module.exports = __webpack_public_path__ + "images/xibao_top_semi_backview_2026-2027_1016.1792157180594.jpg";